import { createSelector } from 'reselect'
import _ from 'lodash'

import parametersSelector from './parameters'

const depositsSelector = state => state.deposits.index

export default createSelector(
  parametersSelector,
  depositsSelector,
  ({ available_currencies }, deposits) => {
    return {
      ...deposits,
      code: deposits.code || _.first(_.keys(available_currencies))
    }
  }
)



// WEBPACK FOOTER //
// ./src/selectors/deposits.js